import React, { Component } from 'react';
import { Icon } from '../../../../../ui-kit';
import '../styles/_interactive-overlay.scss';















export default class InteractiveOverlay extends Component


{
  constructor() {
    super();

    this.state = {
      hovering: false
    };
  }

  getPreviewOverlay() {
    const { hovering } = this.state;
    const {
      playing,
      onPause,
      onPlay,
      onRestart,
      getCurrentTime,
      loading
    } = this.props;

    if (loading) {
      return (
        <div className="interactive-overlay">
          <Icon
            className="interactive-overlay__loading"
            name="shootstagrad"
            size={40}
            color="white"
            spin />

        </div>);

    }

    if (playing && !hovering) {return null;}

    const currentTime = getCurrentTime ? getCurrentTime() : 0;
    const startedAndPaused = currentTime > 0 && !playing;

    return (
      <div className="interactive-overlay">
        {
        startedAndPaused ?

        <Icon
          className="interactive-overlay__restart"
          onClick={onRestart}
          name="previous"
          size={42}
          color="white" /> :


        null}

        {
        playing ?

        <Icon
          key="pause"
          className="interactive-overlay__pause"
          name="pause"
          size={35}
          color="white"
          onClick={onPause} /> :


        null}

        {
        !playing ?

        <Icon
          key="play"
          className="interactive-overlay__play"
          name="play"
          size={35}
          color="white"
          onClick={onPlay} /> :


        null}

      </div>);

  }

  onHover = () => {
    const { hovering } = this.state;

    if (hovering) {return;}

    this.setState({ hovering: true });
  };

  onHoverOut = () => {
    this.setState({ hovering: false });
  };

  render() {
    const { children } = this.props;
    const { hovering } = this.state;

    return children({
      overlay: this.getPreviewOverlay(),
      hovering,
      onMouseOver: this.onHover,
      onMouseLeave: this.onHoverOut
    });
  }
}